const REFERRAL_TOKEN_KEY = 'referralToken';

/**
 * Salva il token referral presente nell'URL (?ref=...) del link di invito,
 * così resta disponibile anche se l'utente naviga prima di registrarsi.
 */
export const captureReferralToken = () => {
  try {
    const token = new URLSearchParams(window.location.search).get('ref');
    if (token) localStorage.setItem(REFERRAL_TOKEN_KEY, token);
  } catch (e) {
    /* storage non disponibile */
  }
};

export const getReferralToken = (): string | null => {
  try {
    return localStorage.getItem(REFERRAL_TOKEN_KEY);
  } catch (e) {
    return null;
  }
};

export const clearReferralToken = () => {
  try {
    localStorage.removeItem(REFERRAL_TOKEN_KEY);
  } catch (e) {
    /* storage non disponibile */
  }
};
